import { render } from "./AdditionalRunnerInfo.vue?vue&type=template&id=50de7aba"
import script from "./AdditionalRunnerInfo.vue?vue&type=script&lang=js"
export * from "./AdditionalRunnerInfo.vue?vue&type=script&lang=js"
script.render = render

export default script